import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import AdminShell, { Panel, Btn } from "@/components/admin/AdminShell";
import { api } from "@/lib/api";

const FIELDS = [
  { group: "OTC Desk", fields: [["otc_maker_pct", "Maker %"], ["otc_taker_pct", "Taker %"]] },
  { group: "P2P Trading", fields: [["p2p_maker_pct", "Maker %"], ["p2p_taker_pct", "Taker %"]] },
  { group: "Withdrawals", fields: [["crypto_withdraw_btc", "BTC withdraw fee"], ["inr_withdraw_fee", "INR withdraw fee (₹)"]] },
  { group: "Referral Program", fields: [["referral_commission_pct", "Commission %"]] },
];

export default function FeeManagement() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => { api.get("/api/admin/fees").then(({ data }) => setF(data)); }, []);
  if (!f) return <AdminShell title="Fees" subtitle="Trading, P2P, OTC and withdrawal fee schedules."><div>Loading…</div></AdminShell>;

  async function save() {
    setSaving(true);
    setMsg("");
    const { data } = await api.put("/api/admin/fees", f);
    setF(data);
    setMsg("Saved");
    setSaving(false);
    setTimeout(() => setMsg(""), 2000);
  }

  return (
    <AdminShell title="Fees" subtitle="Trading, P2P, OTC and withdrawal fee schedules.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {FIELDS.map((g) => (
          <Panel key={g.group} className="p-5" data-testid={`fee-group-${g.group.toLowerCase().replace(/\s+/g, "-")}`}>
            <h3 className="text-[14px] font-semibold mb-4">{g.group}</h3>
            <div className="space-y-3">
              {g.fields.map(([k, lbl]) => (
                <label key={k} className="flex items-center gap-3">
                  <span className="text-[12px] text-muted-foreground flex-1">{lbl}</span>
                  <input
                    type="number"
                    step="0.001"
                    value={f[k] ?? 0}
                    onChange={(e) => setF({ ...f, [k]: Number(e.target.value) })}
                    data-testid={`fee-${k}`}
                    className="w-[140px] h-[36px] px-3 bg-background border border-line rounded-md text-right tabular-nums"
                  />
                </label>
              ))}
            </div>
          </Panel>
        ))}
      </div>
      <div className="mt-5 flex items-center gap-3">
        <Btn onClick={save} disabled={saving} data-testid="save-fees"><Save size={14} /> {saving ? "Saving…" : "Save fees"}</Btn>
        {msg && <span className="text-[13px] text-up">{msg}</span>}
      </div>
    </AdminShell>
  );
}
